import dynamic from 'next/dynamic';
import { COMPONENT_PREFIX } from '../constants';

const addPageBuilderComponents = addComponent => {
  const components = {
    productvariants: dynamic(
      () =>
        import(/* webpackChunkName: "kelShopwareProductVariants" */ '../components/ProductVariants')
    ),
    productprice: dynamic(
      () => import(/* webpackChunkName: "kelShopwareProductPrice" */ '../components/ProductPrice')
    ),
    offermarker: dynamic(
      () => import(/* webpackChunkName: "kelShopwareOfferMarker" */ '../components/OfferMarker')
    ),
    linkqueryparam: dynamic(
      () =>
        import(/* webpackChunkName: "kelShopwareLinkQueryParam" */ '../components/LinkQueryParam')
    ),
    guestregistrationform: dynamic(
      () =>
        import(
          /* webpackChunkName: "kelShopwareGuestRegistrationForm" */ '../components/GuestRegistrationForm'
        )
    )
  };

  Object.entries(components).forEach(([key, component]) => {
    addComponent({ key: `${COMPONENT_PREFIX}${key}`, component });
  });
};

export default addPageBuilderComponents;
